(function() {
  var sid = window.PQC_CONFIG.sid;

  var BASE_CODE  = window.PQC_CONFIG.baseCode;
  var ACTIVE     = (window.Shopify && Shopify.currency && Shopify.currency.active) || BASE_CODE;
  var RATE       = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
  var LOCALE     = window.PQC_CONFIG.locale || undefined;
  var USD_TO_ILS = parseFloat(window.PQC_CONFIG.usdToIls) || 3.7;

  function money(ilsAmount) {
    var amt = ilsAmount * RATE;
    try { return new Intl.NumberFormat(LOCALE, { style:'currency', currency: ACTIVE, maximumFractionDigits: 2 }).format(amt); }
    catch (e) { return ACTIVE + ' ' + amt.toFixed(2); }
  }

  var QTY_TIERS = [
    { min:50,   max:99   },
    { min:100,  max:249  },
    { min:250,  max:499  },
    { min:500,  max:999  },
    { min:1000, max:1999 },
    { min:2000, max:4999 },
    { min:5000, max:null }
  ];
  var SIZES = {
    '0.75': { label:'0.75"', tiers:[10.5, 8.5, 7,   6,   5.0, 3.2, 2.9] },
    '1.0':  { label:'1.0"',  tiers:[13,   10,  8.5, 7,   5.9, 4.0, 3.2] },
    '1.25': { label:'1.25"', tiers:[15,   12,  10,  8.5, 6.8, 4.7, 4.0] },
    '1.5':  { label:'1.5"',  tiers:[17,   14,  11.5,9.5, 7.7, 5.4, 4.3] },
    '1.75': { label:'1.75"', tiers:[19,   15.5,13,  11,  8.6, 6.1, 5.0] },
    '2.0':  { label:'2.0"',  tiers:[21.5, 17,  14,  12,  9.5, 6.8, 5.8] }
  };

  var ADDON_USD = { hardEnamel: 0.20, magnetic: 0.40, uv: 0.20 };
  function addonILS(usd) { return usd * USD_TO_ILS; }

  var ATTACH_LABEL = { butterfly:'Butterfly Clutch', rubber:'Rubber Clutch', magnetic:'Magnetic Back' };

  var state = { size:'1.25', qty:100, enamel:'soft', attach:'butterfly', uv:false, fileName:'', artworkUrl:'', deadline:'No' };

  function $(id) { return document.getElementById(id + '-' + sid); }

  function basePerPin(sizeKey, qty) {
    var tiers = SIZES[sizeKey].tiers;
    for (var i = 0; i < QTY_TIERS.length; i++) {
      var t = QTY_TIERS[i];
      if (qty >= t.min && (t.max === null || qty <= t.max)) return tiers[i];
    }
    return tiers[tiers.length - 1];
  }

  function valid(qty) { return qty && qty >= 50; }

  function update() {
    var qty = state.qty;
    var ok  = valid(qty);

    var base = ok ? basePerPin(state.size, qty) : 0;
    var hard = state.enamel === 'hard' ? addonILS(ADDON_USD.hardEnamel) : 0;
    var mag  = state.attach === 'magnetic' ? addonILS(ADDON_USD.magnetic) : 0;
    var uv   = state.uv ? addonILS(ADDON_USD.uv) : 0;
    var unit = base + hard + mag + uv;
    var total = unit * qty;

    $('pqc-s-unit').textContent  = ok ? money(unit) : '--';
    $('pqc-s-total').textContent = ok ? money(total) : '--';

    updateHidden(ok, unit, total);
    updateSummary(ok, qty, unit, total);
  }

  function updateHidden(ok, unit, total) {
    $('pqc-h-size').value   = SIZES[state.size].label;
    $('pqc-h-qty').value    = state.qty || '';
    $('pqc-h-enamel').value = state.enamel === 'hard' ? 'Hard enamel' : 'Soft enamel';
    $('pqc-h-attach').value = ATTACH_LABEL[state.attach];
    $('pqc-h-uv').value     = state.uv ? 'Yes' : 'No';
    $('pqc-h-deadline').value = state.deadline;
    $('pqc-h-file').value   = state.artworkUrl ? state.artworkUrl : (state.fileName ? state.fileName + ' (not uploaded)' : 'None uploaded');
    $('pqc-h-unit').value   = ok ? money(unit) : 'n/a';
    $('pqc-h-total').value  = ok ? money(total) : 'n/a';
    $('pqc-h-cur').value    = ACTIVE;
  }

  function updateSummary(ok, qty, unit, total) {
    var s = $('pqc-summary'); if (!s) return;
    s.innerHTML =
      '<strong>Your configuration</strong><br>' +
      SIZES[state.size].label + ' · ' + (ok ? qty.toLocaleString() + ' pins' : 'qty TBD') + ' · ' +
      (state.enamel === 'hard' ? 'Hard enamel' : 'Soft enamel') + ' · ' + ATTACH_LABEL[state.attach] +
      (state.uv ? ' · UV printing' : '') +
      (ok ? '<br><strong>Estimate:</strong> ' + money(unit) + '/pin · ' + money(total) + ' total' : '');
  }

  function paintLabels() {
    $('pqc-hard-note').textContent = '+' + money(addonILS(ADDON_USD.hardEnamel)) + '/pin';
    $('pqc-attach-mag').textContent = 'Magnetic Back — +' + money(addonILS(ADDON_USD.magnetic)) + '/pin';
    $('pqc-uv-sub').innerHTML = 'For fine detail &amp; gradients · +' + money(addonILS(ADDON_USD.uv)) + '/pin';
    $('pqc-uv-modal-text').textContent =
      'UV Printing is recommended for artwork with very fine details, gradients, or small text that cannot be achieved with traditional enamel fills. It adds an additional ' +
      money(addonILS(ADDON_USD.uv)) + ' per pin.';
    var cells = document.querySelectorAll('#pqc-size-guide-body-' + sid + ' [data-sgfrom]');
    cells.forEach(function(c) {
      var key = c.getAttribute('data-sgfrom');
      var lowest = SIZES[key].tiers[SIZES[key].tiers.length - 1];
      c.textContent = 'from ' + money(lowest);
    });
  }

  $('pqc-size').addEventListener('change', function() { state.size = this.value; update(); });

  var qtySelect = $('pqc-qty'), customWrap = $('pqc-custom-qty'), customInput = $('pqc-custom-input'), minNote = $('pqc-min-note');
  qtySelect.addEventListener('change', function() {
    if (this.value === 'custom') { customWrap.classList.add('show'); state.qty = parseInt(customInput.value, 10) || 0; }
    else { customWrap.classList.remove('show'); minNote.classList.remove('show'); state.qty = parseInt(this.value, 10); }
    update();
  });
  customInput.addEventListener('input', function() {
    var q = parseInt(this.value, 10) || 0;
    state.qty = q;
    minNote.classList.toggle('show', this.value !== '' && q < 50);
    update();
  });

  var enamelWrap = $('pqc-enamel');
  enamelWrap.querySelectorAll('button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      enamelWrap.querySelectorAll('button').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      state.enamel = this.getAttribute('data-enamel');
      update();
    });
  });

  $('pqc-attach').addEventListener('change', function() { state.attach = this.value; update(); });
  $('pqc-uv').addEventListener('change', function() { state.uv = this.checked; update(); });

  var dlWrap = $('pqc-deadline-toggle'), dlDate = $('pqc-deadline-date');
  if (dlDate) { try { dlDate.min = new Date().toISOString().split('T')[0]; } catch(e){} }
  if (dlWrap) {
    dlWrap.querySelectorAll('button').forEach(function(btn) {
      btn.addEventListener('click', function() {
        dlWrap.querySelectorAll('button').forEach(function(b){ b.classList.remove('active'); });
        this.classList.add('active');
        if (this.getAttribute('data-dl') === 'yes') {
          dlDate.style.display = 'block';
          state.deadline = dlDate.value ? dlDate.value : 'Yes (date not set)';
        } else {
          dlDate.style.display = 'none';
          state.deadline = 'No';
        }
        update();
      });
    });
    dlDate.addEventListener('change', function() { state.deadline = this.value || 'Yes (date not set)'; update(); });
  }

  var CL_CLOUD  = window.PQC_CONFIG.clCloud;
  var CL_PRESET = window.PQC_CONFIG.clPreset;
  var fileInput = $('pqc-file'), uploadZone = $('pqc-upload'), fname = $('pqc-fname'), fnameText = $('pqc-fname-text'), removeBtn = $('pqc-remove-file');

  function setFileState(text, color) {
    fnameText.textContent = text;
    fname.style.color = color || '';
    fname.classList.add('show');
  }
  function clearFile() {
    fileInput.value = ''; state.fileName = ''; state.artworkUrl = '';
    fname.classList.remove('show'); fnameText.textContent = ''; update();
  }
  function uploadFile(file) {
    if (!file) return;
    state.fileName = file.name; state.artworkUrl = '';
    if (!CL_CLOUD || !CL_PRESET) {
      setFileState(file.name + ' — add Cloudinary details in theme settings to enable uploads', '#c2410c');
      update(); return;
    }
    setFileState('Uploading ' + file.name + '…', '');
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', CL_PRESET);
    fetch('https://api.cloudinary.com/v1_1/' + CL_CLOUD + '/auto/upload', { method: 'POST', body: fd })
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (d && d.secure_url) { state.artworkUrl = d.secure_url; setFileState(file.name + ' — uploaded ✓', ''); }
        else { setFileState('Upload failed — please paste a link below or email the file', '#c2410c'); }
        update();
      })
      .catch(function(){ setFileState('Upload failed — please paste a link below or email the file', '#c2410c'); update(); });
  }
  fileInput.addEventListener('change', function() { if (this.files && this.files[0]) uploadFile(this.files[0]); });
  removeBtn.addEventListener('click', function(e) { e.stopPropagation(); clearFile(); });
  uploadZone.addEventListener('dragover',  function(e) { e.preventDefault(); this.classList.add('dragover'); });
  uploadZone.addEventListener('dragleave', function()  { this.classList.remove('dragover'); });
  uploadZone.addEventListener('drop', function(e) {
    e.preventDefault(); this.classList.remove('dragover');
    if (e.dataTransfer.files && e.dataTransfer.files[0]) { fileInput.files = e.dataTransfer.files; uploadFile(e.dataTransfer.files[0]); }
  });

  function open(el)  { el.classList.add('open'); }
  function close(el) { el.classList.remove('open'); }
  $('pqc-get-quote').addEventListener('click', function() { open($('pqc-cq-modal')); });
  $('pqc-size-guide-btn').addEventListener('click', function() { open($('pqc-size-modal')); });
  $('pqc-sg-close').addEventListener('click', function() { close($('pqc-size-modal')); });
  $('pqc-size-modal').addEventListener('click', function(e) { if (e.target === this) close(this); });

  function buildPriceTable() {
    var body = $('pqc-price-table-body');
    if (!body || body.dataset.built === '1') return;
    var keys = ['0.75','1.0','1.25','1.5','1.75','2.0'];
    var html = '';
    for (var k = 0; k < keys.length; k++) {
      var sk = keys[k];
      var t = SIZES[sk].tiers;
      html += '<tr><td><strong>' + SIZES[sk].label + '</strong></td>';
      for (var j = 0; j < t.length; j++) {
        html += '<td>₪' + t[j] + '</td>';
      }
      html += '</tr>';
    }
    body.innerHTML = html;
    body.dataset.built = '1';
  }
  $('pqc-price-table-btn').addEventListener('click', function() { buildPriceTable(); open($('pqc-price-modal')); });
  $('pqc-price-close').addEventListener('click', function() { close($('pqc-price-modal')); });
  $('pqc-price-modal').addEventListener('click', function(e) { if (e.target === this) close(this); });
  $('pqc-enamel-info-btn').addEventListener('click', function() { open($('pqc-enamel-modal')); });
  $('pqc-enamel-close').addEventListener('click', function() { close($('pqc-enamel-modal')); });
  $('pqc-enamel-modal').addEventListener('click', function(e) { if (e.target === this) close(this); });
  $('pqc-uv-info-btn').addEventListener('click', function() { open($('pqc-uv-modal')); });
  $('pqc-uv-close').addEventListener('click', function() { close($('pqc-uv-modal')); });
  $('pqc-uv-modal').addEventListener('click', function(e) { if (e.target === this) close(this); });
  $('pqc-cq-close').addEventListener('click', function() { close($('pqc-cq-modal')); });
  $('pqc-cq-modal').addEventListener('click', function(e) { if (e.target === this) close(this); });

  if (location.search.indexOf('contact_posted=true') !== -1 || document.getElementById('pqc-posted-' + sid)) {
    open($('pqc-cq-modal'));
    var sb = $('pqc-success-banner'); if (sb) sb.style.display = 'block';
  }
  if (document.getElementById('pqc-error-marker-' + sid)) { open($('pqc-cq-modal')); }

  paintLabels();
  update();
})();